const isJordanLat = (value) => value >= 29 && value <= 33.8;
const isJordanLng = (value) => value >= 34.5 && value <= 39.5;
const isLat = (value) => value >= -90 && value <= 90;
const isLng = (value) => value >= -180 && value <= 180;

const toNumber = (value) => {
  if (value === null || value === undefined || value === "") return null;

  const number = Number(value);

  return Number.isFinite(number) ? number : null;
};

export function normalizeLatLngPair(latValue, lngValue) {
  const first = toNumber(latValue);
  const second = toNumber(lngValue);

  if (first === null || second === null) {
    return null;
  }

  if (isJordanLat(first) && isJordanLng(second)) {
    return { lat: first, lng: second, flipped: false };
  }

  if (isJordanLat(second) && isJordanLng(first)) {
    return { lat: second, lng: first, flipped: true };
  }

  if (isLat(first) && isLng(second)) {
    return { lat: first, lng: second, flipped: false };
  }

  if (isLat(second) && isLng(first)) {
    return { lat: second, lng: first, flipped: true };
  }

  return { lat: first, lng: second, flipped: false };
}

export function normalizeCoordinateRecord(record) {
  if (!record) return record;

  const normalized = normalizeLatLngPair(record.lat, record.lng);

  if (!normalized) {
    return record;
  }

  return {
    ...record,
    lat: normalized.lat,
    lng: normalized.lng,
  };
}

export function buildGoogleMapsUrl(latValue, lngValue) {
  const normalized = normalizeLatLngPair(latValue, lngValue);

  if (!normalized) {
    return null;
  }

  return `https://maps.google.com/?q=${normalized.lat},${normalized.lng}`;
}

export function formatCoordinatePair(latValue, lngValue) {
  const lat = toNumber(latValue);
  const lng = toNumber(lngValue);

  if (lat === null || lng === null) {
    return "";
  }

  return `${lat},${lng}`;
}

export function parseCoordinatePair(input) {
  const parts = String(input ?? "")
    .split(",")
    .map((value) => value.trim())
    .filter(Boolean);

  if (parts.length !== 2) {
    return null;
  }

  const lat = Number(parts[0]);
  const lng = Number(parts[1]);

  if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
    return null;
  }

  return { lat, lng };
}